jQuery(function($) {

var l_window = parseInt($(window).width());

/**********************************************************************/
/*************** MUSHROOM - HEADER FIXE ****************/
/**********************************************************************/

 var loycoRso = document.querySelector("header.site-header");
 

function isNavVisible(loycoRso) {
  return (loycoRso.classList.contains('open-s-menu') ? true : false );
}


var options = {
    offset : 150,

    // scroll tolerance in px before state changes
 //   tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },

  onUnpin: function() {
    if ( isNavVisible(loycoRso) ) {
      this.elem.classList.remove(this.classes.unpinned);
      this.elem.classList.add(this.classes.pinned);
    }
    else {
      this.elem.classList.add(this.classes.unpinned);
      this.elem.classList.remove(this.classes.pinned);
    }
  }
};

var headroom  = new Headroom(loycoRso,options);

// initialise
headroom.init();
	

/**********************************************************************/
/*************** NAV / MENU MOBILE // ADD BTN BACK ****************/
/**********************************************************************/

$( "ul.sub-menu" ).each(function( index ) {
  var txt_this_menu =  $( this ).parent().find(">:first-child").text();
  $(this).prepend( '<li class="btn-back">'+txt_this_menu+'</li>');
});

$( "ul.sub-menu > li.btn-back" ).on( "click", function() {
  $(this).parent().parent().removeClass('focus');
} );

// /**********************************************************************/
// /*************** INTRODUCTION / HOME PAGE / DIAPORAMA ****************/
// /**********************************************************************/
	 
var swiper_PSIntro = new Swiper('.js-swiper-HomeIntro', {
  
	  slidesPerView: "auto",
    spaceBetween: 0,
	  loop: true,
	  speed: 8000,
    allowTouchMove: false,
    slideToClickedSlide: false,
	  autoplay: {
	    delay: 1,
	    disableOnInteraction: false
	  },
   
  //watchSlidesProgress: true,
});
  

  
  /**************************************/
/*********** SLIDE LOGO *********/

  var swiper_RefClient = new Swiper('.js-swiper-RefClient', {
  
   
    allowTouchMove: false,
    slideToClickedSlide: false,
    speed: 800,
    spaceBetween: 25,
    slidesPerView: 2,
    slidesPerGroup: 1,
     loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
    breakpoints: {
      2200: { // a partir de 769
        spaceBetween: 20,
        slidesPerView: 12,
        loop: true,
        slideToClickedSlide: true,
        centeredSlides:true
      },
      1355: { // a partir de 769
        spaceBetween: 40,
        slidesPerView: 8,
        loop: true,
        slideToClickedSlide: true,
     //   centeredSlides:true
      }, 1025: { // a partir de 769
        spaceBetween: 20,
        slidesPerView: 6,
        loop: true,
        slideToClickedSlide: true,
      },
      550: { // a partir de 769
         spaceBetween: 35,
        slidesPerView: 3,
        loop: true,
        slideToClickedSlide: true,
      }
  },
   navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
   
  //watchSlidesProgress: true,
});

  /*****************************/
  

    /******************************************/
    /******* SLIDER HOTSPOT POUR MOBILE - PAGES SERVICE *****/
    /******************************************/
       if ( $( ".HotSpot-Button" ).length ) {  

    //   $('.js-slider-interactivite').slick({
    //       arrows: true,
    //       autoplay:true,
    //       autoplaySpeed: 4000,
    //       slidesToScroll: 1,
    //       slidesToShow: 1,
    //       dots:false,
    //       pauseOnFocus:false,
    //       pauseOnHover:false,
    //       infinite:true,
    //       mobileFirst: true,
    //       responsive: [
    //       {
    //               breakpoint: 768,
    //               settings: 'unslick'
    //       }
    //     ]
    // });
     

      tippy('.HotSpot-Button', {
        content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
      },
      allowHTML: true,
      interactive: true,
      maxWidth: 500,
      theme: 'wesign',
      offset: [15, 15],
      animation: 'rotate',
      moveTransition: 'transform 0.2s ease-out',
      appendTo: () => document.body,
      onTrigger(instance, event) {
        // if(l_window < 768){
        //   let id_instance = instance.id;
        //   $('.js-slider-interactivite').slick('slickGoTo', id_instance - 1);
          
        //   offsetTop = $('.InteractiveValeur').offset().top-header.height();
        //   $('html, body').stop().animate({ 
        //       scrollTop: offsetTop
        //   }, 600);

        // }
        //console.log(instance.);
      //console.log(instance.getAttribute('data-template'));
      }
    });

    } // si page entreprise




 /**********************************************************************/
/*************** SLIDER  / GALERIE DANS LES PAGES DE SERVICES  ****************/
/**********************************************************************/

    if ($("#gallery-thumb").length) {
      // Do something
     
      lightGallery(document.getElementById('gallery-thumb'), {
          plugins: [lgThumbnail],
          selector: '.item-img',
          thumbnail: true
      });

  }   

    var swiper_ref = new Swiper('.js-swiper-RefGallerie', {
       spaceBetween: 35,
       slidesPerView: 1.5,
       loop: true,
       slideToClickedSlide: true,
          autoplay: {
            delay: 6000,
            disableOnInteraction: false
          },
        breakpoints: {
          2200: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 9,
  
  
            loop: true,
            slideToClickedSlide: true,
          },
          1355: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 5,
  
  
            loop: true,
            slideToClickedSlide: true,
          }, 1025: { // a partir de 769
            spaceBetween: 20,
            slidesPerView: 4,
  
  
            loop: true,
            slideToClickedSlide: true,
          },
          601: { // a partir de 769
             spaceBetween: 15,
            slidesPerView: 2,
  
  
            loop: true,
            slideToClickedSlide: true,
          }
      },


      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },

    //watchSlidesProgress: true,
  });





  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });




  /**************************************************************************************/
/*********************** START ISOTOPE ALL REFERENCES FILTER *********************************/
  /**************************************************************************************/
    
       /* Masonry Project archive */  
      var $container_all_ref = $('.ref-all-masonry');
      var grid_isotope;
      var class_filter_init = '*';
     
     $container_all_ref.imagesLoaded(function () {
      $grid_isotope = $container_all_ref.isotope({
              itemSelector: '.item-img',
              percentPosition: true,
              filter:class_filter_init,
              sortBy : 'random',
               masonry: {
              columnWidth: '.item-img-sizer',
              gutter: '.item-img-gutter',
          }
      });
     });


     $('.filter-button-group').on( 'click', 'button', function() {
      var filterValue = $(this).attr('data-filter');
      $('.filter-button-group button').removeClass('active');
      $(this).addClass('active');
      $grid_isotope.isotope({ filter: filterValue });
    });





}); 



